package uz.ferro.erp.pages

import mui.material.Box
import mui.material.Stack
import mui.material.StackDirection
import mui.system.responsive
import mui.system.sx
import react.ChildrenBuilder
import react.FC
import react.Props
import react.useContext
import uz.ferro.erp.AppContext
import uz.ferro.erp.LocaleContext
import uz.ferro.erp.NavigationContext
import web.cssom.Auto
import web.cssom.Position
import web.cssom.pct
import web.cssom.px

private const val MAX_WIDTH = 1280
const val PADDING = 16

val MAX_PAGE_AREA = (MAX_WIDTH + 2 * PADDING).px

fun BasePage(
    hideHeaderBack:Boolean = false,
    fullBlock: ChildrenBuilder.(props: Props) -> Unit = {},
): FC<Props> {

    val fullElement = FC(fullBlock)

    return FC {
        val locale = useContext(LocaleContext)
        val navigator = useContext(NavigationContext)
        val appContext = useContext(AppContext)

        Box {
            sx {
                position = Position.absolute
                top = 0.px
                right = 0.px
                bottom = 0.px
                left = 0.px
            }

            Stack {
                direction = responsive(StackDirection.column)
                sx {
                    height = 100.pct
                }

                Box {
                    sx {
                        width = 100.pct
                        height = 100.pct
                        maxWidth = MAX_PAGE_AREA
                        marginLeft = Auto.auto
                        marginRight = Auto.auto
                        marginTop = 16.px
                        paddingLeft = 16.px
                        paddingRight = 16.px
                        overflow = Auto.auto
                    }

                    fullElement()
                }
            }
        }
    }
}